"use client";

import { Core } from "@faire/design-tokens";
import type { IconId, IconSet } from "@faire/web/slate/icons/__generated__";
import React, { type JSX } from "react";

import { SVGIcon } from "../icons/SVGIcon";

export interface IToastIconProps {
  icon: IconId | JSX.Element;
}

export const ToastIcon = ({ icon }: IToastIconProps) => {
  const [element, setElement] = React.useState<JSX.Element>(
    typeof icon !== "string" ? icon : <></>
  );

  React.useEffect(() => {
    if (typeof icon !== "string") {
      setElement(icon);
      return;
    }

    let lazyload:
      | undefined
      | Promise<
          Record<
            string,
            (props: Partial<SVGIcon.IProps & SVGElement>) => JSX.Element
          >
        > = undefined;
    const [iconSet, iconName] = icon.split(":") as [IconSet, string];
    switch (iconSet) {
      case "legacy":
        lazyload = import("@faire/web/slate/icons/__generated__/icons") as any;
        break;
      case "external":
        lazyload = import(
          "@faire/web/slate/icons/__generated__/externalIcons"
        ) as any;
        break;
      case "foundation":
        lazyload = import(
          "@faire/web/slate/icons/__generated__/foundationIcons"
        ) as any;
        break;
    }
    if (lazyload) {
      lazyload.then((module) => {
        const Icon = module[iconName]!;
        setElement(<Icon fontSize="24px" color={Core.icon.inverse} />);
      });
    }
  }, [icon]);

  return element;
};
